module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/llsyJL/tc-custom/9781426841996.jpg?1705026343087",
      "alt": "This image is the cover for the book One-Night Wife, The O'Connells"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("One-Night Wife, The O'Connells\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('i', [_vm._v("The bride-to-be...")]), _c('br'), _c('br'), _vm._v("Penniless Savannah knows that to help her sick little sister she has to win big at the casino."), _c('br'), _c('br'), _c('i', [_vm._v("The groom...")]), _c('br'), _c('br'), _vm._v("But Sean O'Connell always plays to win..."), _c('br'), _c('br'), _c('i', [_vm._v("The indecent proposal...")]), _c('br'), _c('br'), _vm._v("Virgin Savannah is no match for Sean and soon she's lost everything! Sean offers her one last gamble: he'll settle her debts if she becomes his wife...for just one night!\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sandra Marton\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Sandra Marton is a USA Todday Bestselling Author. A four-time finalist for the RITA, the coveted award given by Romance Writers of America, she's also won eight Romantic Times  Reviewers’ Choice Awards, the Holt Medallion, and Romantic Times’ Career Achievement Award. Sandra's heroes are powerful, sexy, take-charge men who think they have it all--until that one special woman comes along. Stand back, because together they're bound to set the world on fire.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0